import cn from 'classnames';
import React from 'react';
import OfficePopup from 'components/Popups/OfficePopup';
import { getCoordinatesWithOffset } from 'utils/officesMap';
import * as styles from './CityesList.module.scss';

function CitiesList({
  offices,
  setCoordinates,
  selectedOffice,
  setSelectedOffice,
  isSmallScreenVersion,
}) {
  const isActive = item => selectedOffice?.office.id === item.id;

  const clickHandler = office => {
    setSelectedOffice(prev => ({ ...prev, office, firstRender: false }));

    setCoordinates(getCoordinatesWithOffset(office.coordinates, office.latOffset));
  };

  return (
    <ul className={styles.list}>
      {offices.map(office => {
        if (isSmallScreenVersion) {
          return (
            <OfficePopup
              key={office.id}
              className={styles.smallScreenItem}
              title={`${office?.city}, ${office?.country}`}
              category={office?.category}
              address={office?.address}
              phone={office?.phone}
              images={office?.images}
            />
          );
        }
        return (
          <li
            key={office.id}
            onClick={() => clickHandler(office)}
            className={cn(styles.item, isActive(office) && styles.active)}
          >
            {office.city}
          </li>
        );
      })}
    </ul>
  );
}

export default CitiesList;
